import React from 'react';
import { MessageSchema, AttachedMsg } from '../types';
import { EmptyMessage } from './EmptyMessage';
import style from '../message.module.scss';
import { Switch } from '../../../../chat/components';
import { Content } from '../../../../chat/pages/content/types';
import { SetState } from '../../../../chat/types';
import { ReactSortable } from 'react-sortablejs';
import { sortableOptions } from './OnEnter';
import { PreviewContent } from './PreviewContent';

type Props = {
	message: MessageSchema;
	viewPanel: (visibility: boolean) => void;
	toggleShouldWait: () => void;
	contents: Content[];
	removeAction: (index: number) => void;
	setEditAction: SetState<any>;
	lock: boolean;
	setList: (data: AttachedMsg[]) => void;
};

export function OnReceive(props: Props) {
	const {
		message,
		viewPanel,
		toggleShouldWait,
		contents,
		removeAction,
		setEditAction,
		lock,
		setList,
	} = props;
	const onReceive = message.onReceive;

	const styles: Record<string, string> = {
		'--checked-bg': message.waitForUserMessage ? '#F1722E' : '',
	};

	return (
		<>
			<div className={style.shouldWait} style={styles}>
				<p>Wait for user message</p>
				<Switch
					disabled={lock}
					checked={message.waitForUserMessage}
					onSwitch={toggleShouldWait}
				/>
			</div>
			{message.waitForUserMessage ? (
				onReceive.length ? (
					<div className={style.list}>
						<ReactSortable
							list={onReceive as any}
							setList={setList as any}
							className={style.list}
							{...sortableOptions}
						>
							{onReceive
								.map((msg, index) => {
									return (
										<PreviewContent
											contents={contents}
											lock={lock}
											index={index}
											setEditAction={setEditAction}
											removeAction={removeAction}
											key={msg._id}
											msg={msg}
										/>
									);
								})}
						</ReactSortable>
					</div>
				) : (
					<EmptyMessage lock={lock} onAdd={() => viewPanel(true)} />
				)
			) : null}
		</>
	);
}
